import { http } from '@/core/api/';
const apiUrl = 'api/materialsandequipments';

export default {
  getCategories() {
    return http.get(`${apiUrl}/categories`);
  },
  getSaloon() {
    return http.get(`${apiUrl}/saloonTypes`);
  },
  add(data) {
    return http.post(apiUrl, data);
  },
  search(params) {
    return http.get(`${apiUrl}/search`, { params });
  },
  get(id) {
    return http.get(`${apiUrl}/${id}`);
  },
  getMaterial(materialId) {
    return http.get(`${apiUrl}/material/${materialId}`);
  },
  load(payload) {
    return http.post(`${apiUrl}/savematerial`, payload);
  },
  editMaterial(materialId, payload) {
    return http.put(`${apiUrl}/materials/${materialId}/edit`, payload);
  },
  getInventoryStatus() {
    return http.get(`${apiUrl}/inventorystatuses`);
  },
  getKeyValue() {
    return http.get(`${apiUrl}/keyvalue`);
  },
  getMaterialsCatalog(catalogId) {
    return http.get(`${apiUrl}/materialscatalog/${catalogId}`);
  },
  markAvailable(id) {
    return http.put(`${apiUrl}/materials/${id}/markavailable`);
  },
  eliminateMaterial(id) {
    return http.post(`${apiUrl}/material/${id}/eliminate`);
  },
  getSearchMaterials(id, orderId, params) {
    return http.post(`${apiUrl}/materials/${id}/${orderId}/details`, params);
  },
  getSearchMaterialsSummary(id, orderId, params) {
    return http.post(`${apiUrl}/materials/${id}/${orderId}/summary`, params);
  },
  assignCenterToMaterial(ids, centerId) {
    return http.patch(`${apiUrl}/material/center/${centerId}`, ids);
  },
  updateLocation(payload) {
    return http.patch(`${apiUrl}/materials/location`, payload);
  },
  applyActionToMaterial(action, data) {
    return http.post(`${apiUrl}/materials/${action}/apply`, data);
  },
  inactiveMaterial(id) {
    return http.post(`${apiUrl}/material/${id}/inactive`);
  },
  eliminateMaterial(id) {
    return http.post(`${apiUrl}/material/${id}/eliminate`);
  },
  getTypeFacilities() {
    return http.get(`${apiUrl}/typefacilities`);
  },
  getReasonsByType(reasonTypeId) {
    return http.get(`${apiUrl}/reasons/${reasonTypeId}`);
  },
  getStudents(query) {
    return http.get(`${apiUrl}/searchstudents?query=${query}`);
  },
  cancelTransfer(data) {
    return http.post(`${apiUrl}/transfer/cancel/`, data);
  },
  loan(data) {
    return http.post(`${apiUrl}/loan/`, data);
  },
  addMaterialBinnacle(id, data) {
    return http.post(`${apiUrl}/material/${id}/binnacle`, data);
  },
  getMaterialBinnaclesHistory(materialId) {
    return http.get(`${apiUrl}/material/${materialId}/binnacles`);
  },
  getMaterialDetails(id) {
    return http.get(`${apiUrl}/material/${id}/detail`);
  },
  getInventoryManagementFilters(id) {
    return http.get(`${apiUrl}/${id}/inventorymanagementfilters`);
  },
  getLoanInformation(id) {
    return http.get(`${apiUrl}/material/${id}/loan`);
  },
  notifyReturn(id, payload) {
    return http.post(`${apiUrl}/materials/${id}/notifyreturn`, payload);
  },
  getMaterialTransferHistory(id) {
    return http.get(`${apiUrl}/${id}/materialtransfer/log`);
  },
  getInititalReturnDate(id) {
    return http.get(`${apiUrl}/materials/${id}/inititalreturndate`);
  },
  getDocumentsToConfiscate(id) {
    return http.get(`${apiUrl}/materials/${id}/documentstoconfiscate`);
  },
  consfiscateMaterial(data) {
    return http.post(`${apiUrl}/consfiscate`, data);
  },
  nofityLoanExtensionDate(data) {
    return http.post(`${apiUrl}/nofityloanextensiondate/`, data);
  },
  assignToOrder(id, orderId) {
    return http.post(`${apiUrl}/materials/${id}/assign/order/${orderId}`);
  },
  getAssignmentHistory(id) {
    return http.get(`${apiUrl}/material/${id}/assignmenthistory`);
  },
  assignStudent(id, data) {
    return http.post(`${apiUrl}/materials/${id}/student/assign`, data);
  },
  unassignStudent(id, data) {
    return http.post(`${apiUrl}/materials/${id}/student/unassign`, data);
  },
  getMaterialStudentUnassignReasons(type) {
    return http.get(`${apiUrl}/materials/students/unassign/reasons`, {
      params: { type },
    });
  },
  unassignMaterial(id) {
    return http.post(`${apiUrl}/material/${id}/unassign`);
  },
};
